module.exports = {
	"root": "findify-components--button",
	"raw": "findify-components--button__raw"
};